// components/Slider.js
import '../vendor/nalu-slider.js';
import $ from 'jquery';

const now = () => (typeof performance !== 'undefined' ? performance.now() : Date.now());

// Gated diagnostic (mirrors naluDebug in BookingForm) — only when WP_DEBUG is on.
const sliderDebug = (...args) => {
  if (typeof window !== 'undefined' && window.naluBookingVars?.debug) {
    // eslint-disable-next-line no-console
    console.log('[slider]', ...args);
  }
};

// Initialize ONE card slider. This is the original per-element logic, unchanged
// — it's the Slick fork's synchronous reflow + slide cloning here that is
// expensive, which is why callers must spread these across frames (below).
function initOne(el) {
  if (!el || el.dataset.sliderReady) return;

  // Count slides (markup uses .nalu-slide wrappers).
  const slideCount = el.querySelectorAll('.nalu-slide').length;

  // 0–1 image: not a slider (no dots/arrows).
  if (slideCount <= 1) {
    el.dataset.sliderReady = '1';
    el.classList.add('is-single'); // optional hook for CSS
    return;
  }

  el.dataset.sliderReady = '1';
  $(el).nalu({ arrows: true, dots: true, rows: 1, slidesToShow: 1, adaptiveHeight: true });
}

/**
 * Upgrade every card slider inside `ctx` — but OFF the first-paint critical
 * path. The Slick fork does synchronous reflow + slide cloning per slider, so
 * running them all in the same task as the innerHTML write blocked first paint
 * for seconds on image-heavy Step 2/3. Instead we yield to a rAF, then upgrade
 * sliders in frame-budgeted batches: each batch runs for at most ~8ms (half a
 * frame) before yielding, so the page paints the cards almost immediately and
 * stays responsive while the sliders enhance progressively.
 *
 * A CSS rule (.nalu-tours__card-slider:not([data-slider-ready])) collapses an
 * un-upgraded slider to its first slide, so there's no flash of stacked images
 * during the brief window before each slider is initialized.
 */
export function initSliders(ctx = document) {
  const targets = Array.from($('.nalu-tours__card-slider', ctx)).filter(el => !el.dataset.sliderReady);
  if (!targets.length) return;

  const t0 = now();
  let i = 0;

  const pump = () => {
    const frameStart = now();
    // Always make progress (at least one per frame), then keep going until the
    // ~8ms budget is spent so we never blow a frame.
    do {
      initOne(targets[i++]);
    } while (i < targets.length && (now() - frameStart) < 8);

    if (i < targets.length) {
      requestAnimationFrame(pump);
    } else {
      sliderDebug(`upgraded ${targets.length} slider(s) in ${Math.round(now() - t0)}ms`);
    }
  };

  // Defer to the next frame so the just-written cards paint before the heavy
  // upgrade work begins.
  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(pump);
  } else {
    pump();
  }
}
